import * as React from 'react'
import { Dropdown, makeStyles, Option, useId } from '@fluentui/react-components'
import type {
  DropdownProps,
  OptionOnSelectData
} from '@fluentui/react-components'

type SelectedOption = {
  id: string
  name: string
} | null

type CustomDropdownProps = Partial<DropdownProps> & {
  label: string
  customPlaceholder: string
  options: {
    id: string
    name: string
  }[]
  selectedOption: SelectedOption
  onOptionChange: (option: SelectedOption) => void
}

const useStyles = makeStyles({
  root: {
    display: 'grid',
    gridTemplateColumns: 'auto',
    gridTemplateRows: 'repeat(1fr)',
    justifyItems: 'start',
    gap: '10px',
    minWidth: '48%',
    boxSizing: 'border-box'
  }
})

const CustomDropdown: React.FC<CustomDropdownProps> = ({
  label,
  customPlaceholder,
  options,
  selectedOption,
  onOptionChange,
  ...props
}) => {
  const dropdownId = useId('dropdown-default')
  const styles = useStyles()

  const handleOptionSelect = (
    event: React.SyntheticEvent,
    data: OptionOnSelectData
  ) => {
    // handle clear button click
    if (data.optionText === undefined) {
      onOptionChange(null)
    } else {
      const selectedOption = options.find(
        (option) => option.name === data.optionText
      )
      if (selectedOption) {
        onOptionChange(selectedOption)
      }
    }
  }

  return (
    <div className={styles.root}>
      <label id={dropdownId}>{label}:</label>
      <Dropdown
        clearable
        aria-labelledby={dropdownId}
        placeholder={customPlaceholder}
        size="large"
        style={{ width: '100%' }}
        value={selectedOption?.name || ''}
        onOptionSelect={handleOptionSelect}
        {...props}
      >
        {options.map((option) => (
          <Option key={option.id}>{option.name}</Option>
        ))}
      </Dropdown>
    </div>
  )
}

export default CustomDropdown
